/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormControl,
  FormGroup,
  FormLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  CircularProgress,
  Typography,
  Select,
  MenuItem,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardContent,
} from "@material-ui/core";

import {
  ExpandMore as ExpandMoreIcon,
  KeyboardArrowDown,
} from "@material-ui/icons";

import { createStyles, makeStyles, withStyles } from "@material-ui/core/styles";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import ImagePlaceholder from "components/Image/ImagePlaceholder";
import componentStylesDialog from "assets/theme/components/dialog";
import LoadingData from "components/Loading/LoadingData";
import OrderConfirmation from "./DialogTrocaDevolucaoConfirmacaoPedido";
import useLogs from "hooks/logs";
import { IsMobile } from "utils/is-mobile";

const useStyles = makeStyles({
  paper: { overflow: "hidden" },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  image: {
    width: 80,
    height: 80,
  },
  buttonStyle: {
    border: "none",
    background: "transparent",
    color: "grey",
    "&:hover": {
      color: "#DF767D",
      textDecoration: "underline",
    },
  },
});

const useStylesRadio = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "5rem",
        height: "5rem",
      },
    },
  })
);

const useStylesDialog = makeStyles(componentStylesDialog);

const RadioOption = withStyles(() => ({
  label: {
    fontSize: "0.95rem",
  },
  root: {
    marginBottom: 0,
  },
}))(FormControlLabel);

const typeExchangeList = [
  {
    name: "Devolução",
    value: "DEVOLUCAO",
    id: 1,
  },
  {
    name: "Troca",
    value: "TROCA",
    id: 2,
  },
];

const ProductExchangeDialog = ({
  itens,
  idPessoaLoja,
  idPedido,
  onClose,
  idTrocaDevolucao,
}) => {
  const snackbar = useSnackbar();
  const classes = { ...useStyles(), ...useStylesDialog(), ...useStylesRadio() };
  const detailsRef = useRef(null);
  const history = useHistory();
  const { setLocalStorageApiProblem } = useLogs();

  const isMobile = IsMobile();

  const [expanded, setExpanded] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [searching, setSearching] = useState(false);
  const [listItens, setListItens] = useState([]);
  const [listExchangeProducts, setListExchangeProducts] = useState([]);
  const [listUnavailableItems, setListUnavailableItems] = useState([]);
  const [exchangeData, setExchangeData] = useState(null);
  const [listItemsToChange, setListItemsToChange] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [generalConfiguration, setGeneralConfiguration] = useState({
    type: "DEVOLUCAO",
    reason: "",
    observation: "",
  });

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleGetListExchanges = async () => {
    setSearching(true);

    await Api.get(
      "list-order-change-product",
      "trocas",
      "?idPessoaLoja=" + idPessoaLoja + "&idPedido=" + idPedido,
      true
    )
      .then((res) => {
        if (res?.Result?.ListaPedidoTrocaDevolucao?.length !== 0) {
          setExchangeData(res?.Result?.ListaPedidoTrocaDevolucao);
          setListExchangeProducts(
            res?.Result?.ListaPedidoTrocaDevolucao[0]?.ListDevolucaoTroca
          );
        } else {
          setExchangeData(null);
          setListExchangeProducts([]);
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "153",
          screen: "Trocas / Devoluções Prateleira Infinita",
          problem: `Erro na chamada do endpoint list-order-change-product - ${error}`,
        });
      })
      .finally(() => {
        setSearching(false);
      });
  };

  const onSubmit = async () => {
    const listExchanges = [];
    let newObject = {};
    setSubmitting(true);

    if (listExchangeProducts?.length === 0) {
      listItemsToChange?.map((item) => {
        if (item?.Motivo && item?.QuantidadeSolicitada) {
          newObject = {
            idProduto: item?.IdProduto,
            motivo: item?.Motivo,
            quantidadeTroca: item?.QuantidadeSolicitada,
            tipoSolicitacao: item?.Tipo,
            observacao: item?.Observacao,
            idPedido: idPedido,
          };
          listExchanges.push(newObject);
        }
      });
    } else {
      listItemsToChange?.map((item) => {
        if (item?.Motivo && item?.QuantidadeSolicitada) {
          newObject = {
            idTrocaDevolucaoItem: item?.IdTrocaDevolucaoItem || 0,
            idProduto: item?.IdProduto,
            motivo: item?.Motivo,
            quantidadeTroca: item?.QuantidadeSolicitada,
            tipoSolicitacao: item?.Tipo,
            observacao: item?.Observacao,
            idPedido: idPedido,
          };
          listExchanges.push(newObject);
        }
      });
    }

    listExchangeProducts?.length === 0
      ? await Api.post(
          "create-order-change-product",
          "trocas",
          {
            idPessoaLoja: idPessoaLoja,
            idPedido: idPedido,
            itens: listExchanges,
          },
          true
        )
          .then((res) => {
            if (res?.Success) {
              snackbar.showMessage("Solicitação realizada com sucesso!", {
                severity: "success",
              });
              onClose();
              return history.push(
                `/admin/trocas-devolucoes-prateleira-infinita?numeroPedido=${idPedido}`
              );
            }
          })
          .catch((error) => {
            console.log(error);
            snackbar.showMessage(error, {
              severity: "error",
            });
            setLocalStorageApiProblem({
              idMenuAccess: "153",
              screen: "Trocas / Devoluções Prateleira Infinita",
              problem: `Erro na chamada do endpoint create-order-change-product - ${error}`,
            });
          })
          .finally(() => setSubmitting(false))
      : await Api.put(
          "edit-order-change-product",
          "trocas",
          {
            idTrocaDevolucao: exchangeData
              ? exchangeData[0]?.IdTrocaDevolucao
              : idTrocaDevolucao,
            itens: listExchanges,
          },
          true
        )
          .then((res) => {
            if (res?.Success) {
              snackbar.showMessage("Solicitação realizada com sucesso!", {
                severity: "success",
              });
              onClose();
              return history.push(
                `/admin/trocas-devolucoes-prateleira-infinita?numeroPedido=${idPedido}`
              );
            }
          })
          .catch((error) => {
            console.log(error);
            snackbar.showMessage(error, {
              severity: "error",
            });
            setLocalStorageApiProblem({
              idMenuAccess: "153",
              screen: "Trocas / Devoluções Prateleira Infinita",
              problem: `Erro na chamada do endpoint edit-order-change-product - ${error}`,
            });
          })
          .finally(() => setSubmitting(false));
  };

  const verifyRequiredProps = () => {
    const listItensToChange = [];

    listItens?.forEach((item) => {
      if (
        (item?.Motivo !== "" && item?.QuantidadeSolicitada === "") ||
        (item?.Motivo === "" && item?.QuantidadeSolicitada !== "")
      ) {
        return snackbar.showMessage(
          "Verifique as informaçõs enviadas. Os campos motivo e quantidade são obrigatórios.",
          {
            severity: "error",
          }
        );
      } else if (item?.Motivo !== "" && item?.QuantidadeSolicitada !== "") {
        listItensToChange?.push(item);
      }
    });

    if (listItensToChange?.length !== 0) {
      setListItemsToChange(listItensToChange);
      setOpenConfirmation(true);
    }
  };

  useEffect(() => {
    let newObject = {};
    const list = [];
    if (itens) {
      itens?.map((item) => {
        newObject = {
          Ativo: item?.Ativo,
          DescricaoProduto: item?.DescricaoProduto,
          Foto: item?.Foto,
          IdAtendimentoApp: item?.IdAtendimentoApp,
          IdAtendimentoAppItem: item?.IdAtendimentoAppItem,
          IdProduto: item?.IdProduto,
          QuantidadeOriginal: item?.Quantidade,
          QuantidadeTrocaDev: null,
          QuantidadeRestante: null,
          QuantidadeSolicitada: "",
          Motivo: "",
          Tipo: "DEVOLUCAO",
          Observacao: "",
          IdTrocaDevolucaoItem: null,
        };
        list.push(newObject);
      });
      setListItens(list);
    }
  }, [itens]);

  useEffect(() => {
    if (listItens?.length !== 0) {
      if (listExchangeProducts?.length !== 0) {
        const listItems = listItens.map((item) => {
          const compareItens = listExchangeProducts.find(
            (change) => item?.IdProduto === change?.IdProduto
          );

          if (compareItens) {
            return {
              ...item,
              Tipo: compareItens?.TipoSolicitacao,
              IdTrocaDevolucaoItem: compareItens?.IdTrocaDevolucaoItem,
              QuantidadeTrocaDev: compareItens?.QuantidadeTroca,
              QuantidadeRestante:
                item?.QuantidadeOriginal - compareItens?.QuantidadeTroca,
            };
          }
          return item;
        });

        const listUnavailable = [];
        const listAvailable = [];

        listItems?.map((item) => {
          if (item?.QuantidadeRestante === 0) {
            listUnavailable?.push(item);
          } else {
            listAvailable?.push(item);
          }
        });

        setListItens(listAvailable);
        setListUnavailableItems(listUnavailable);
      }
    }
  }, [listExchangeProducts, itens]);

  useEffect(() => {
    if (idPessoaLoja && idPedido) {
      handleGetListExchanges();
    }
  }, [idPessoaLoja, idPedido]);

  return (
    <Dialog
      open={Boolean(itens)}
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      classes={{ paper: classes.paper }}
      maxWidth="lg"
    >
      <div
        className={classes.dialogHeader}
        style={{
          display: "flex",
          justifyContent: isMobile ? "flex-start" : "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <Typography variant="h5" component="h5" className={classes.dialogTitle}>
          Solicitação de Troca / Devolução
        </Typography>
        <Typography
          variant="h5"
          component="h5"
          className={classes.dialogTitle}
          style={{ marginTop: isMobile ? "0.5rem" : 0 }}
        >
          Pedido {idPedido}
        </Typography>
      </div>

      <>
        {searching ? (
          <Grid item xs={12}>
            <LoadingData
              searching={searching}
              classes={classes.root}
              label="Buscando dados..."
              hiddenIcon={true}
            />
          </Grid>
        ) : (
          <>
            <DialogContent
              ref={detailsRef}
              style={{
                paddingRight: "0px",
                marginRight: "1.5rem",
                overflowX: "hidden",
              }}
            >
              <>
                <Grid container>
                  <Grid item xs={12}>
                    <Grid
                      container
                      hidden={listItens?.length === 0 || searching}
                    >
                      <Grid item xs={12}>
                        <Accordion
                          expanded={expanded === "disponiveis"}
                          onChange={handleChange("disponiveis")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Typography
                              style={{ fontWeight: "bold" }}
                              className={classes.heading}
                            >
                              Itens Disponíveis
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails
                            style={{
                              padding: 0,
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Grid
                              container
                              hidden={listItens?.length < 2}
                              style={{ margin: "1rem" }}
                            >
                              <Grid item xs={12}>
                                <Grid container style={{ display: "flex" }}>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <FormGroup style={{ marginTop: "0.25rem" }}>
                                      <FormLabel style={{ fontSize: "12px" }}>
                                        MOTIVO
                                      </FormLabel>
                                      <FormControl
                                        variant="outlined"
                                        fullWidth
                                        disabled={submitting}
                                      >
                                        <Select
                                          name="motivo"
                                          value={generalConfiguration?.reason}
                                          onChange={(e) =>
                                            setGeneralConfiguration({
                                              ...generalConfiguration,
                                              reason: e.target.value,
                                            })
                                          }
                                          IconComponent={KeyboardArrowDown}
                                        >
                                          <MenuItem value={"ARREPENDIMENTO"}>
                                            Arrependimento/Desistência
                                          </MenuItem>
                                          <MenuItem value={"DEFEITO"}>
                                            Produto com defeito
                                          </MenuItem>
                                          <MenuItem value={"NAOGOSTOU"}>
                                            Não gostou
                                          </MenuItem>
                                          <MenuItem value={"OUTROS"}>
                                            Outros
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </FormGroup>
                                    <FormGroup>
                                      <FormLabel style={{ fontSize: "12px" }}>
                                        TIPO DE SOLICITAÇÃO
                                      </FormLabel>
                                      <RadioGroup
                                        aria-label="opções de solicitação"
                                        required
                                        name="tipo"
                                        value={generalConfiguration?.type}
                                        disabled={submitting}
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                        onChange={(e) => {
                                          setGeneralConfiguration({
                                            ...generalConfiguration,
                                            type: e.target.value,
                                          });
                                        }}
                                      >
                                        {typeExchangeList.map((type) => {
                                          return (
                                            <RadioOption
                                              className={
                                                classes.smallRadioButton
                                              }
                                              key={type?.id}
                                              value={type?.value}
                                              checked={
                                                generalConfiguration?.type ===
                                                type?.value
                                              }
                                              control={
                                                <Radio color="primary" />
                                              }
                                              label={type.name}
                                            />
                                          );
                                        })}
                                      </RadioGroup>
                                    </FormGroup>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    style={{
                                      marginTop: isMobile ? "-1.5rem" : 0,
                                    }}
                                  >
                                    <FormGroup>
                                      <FormLabel style={{ fontSize: "12px" }}>
                                        OBSERVAÇÃO
                                      </FormLabel>
                                      <TextField
                                        name="observacao"
                                        fullWidth
                                        multiline
                                        rows="5"
                                        onChange={(e) => {
                                          setGeneralConfiguration({
                                            ...generalConfiguration,
                                            observation: e.target.value,
                                          });
                                        }}
                                        disabled={submitting}
                                        value={
                                          generalConfiguration?.observation
                                        }
                                        variant="outlined"
                                        inputProps={{ min: 0 }}
                                        onInput={(e) => {
                                          e.target.value = e.target.value
                                            .toString()
                                            .slice(0, 250);
                                        }}
                                      />
                                    </FormGroup>
                                  </Grid>
                                </Grid>
                                <Grid
                                  container
                                  style={{
                                    display: "flex",
                                    justifyContent: isMobile
                                      ? "center"
                                      : "flex-start",
                                    alignItems: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#f5365c",
                                      marginLeft: "10px",
                                      marginBottom: isMobile ? "1rem" : 0,
                                    }}
                                  >
                                    * As quantidades dos itens para
                                    troca/devolução devem ser alteradas
                                    individualmente
                                  </span>
                                </Grid>
                                <Grid
                                  container
                                  style={{
                                    display: "flex",
                                    justifyContent: isMobile
                                      ? "center"
                                      : "flex-end",
                                    alignItems: "center",
                                  }}
                                >
                                  <div role="presentation">
                                    <Button
                                      component={Box}
                                      color="default"
                                      onClick={() => {
                                        setListItens(
                                          listItens.map((item) => {
                                            return {
                                              ...item,
                                              Tipo: "DEVOLUCAO",
                                              Observacao: "",
                                              Motivo: "",
                                            };
                                          })
                                        );
                                      }}
                                      disabled={submitting}
                                      className={classes.buttonStyle}
                                      style={{
                                        marginRight: isMobile ? 0 : "0.5rem",
                                        width: isMobile ? "100%" : "auto",
                                      }}
                                    >
                                      Limpar campos
                                    </Button>
                                    <Button
                                      component={Box}
                                      color="default"
                                      variant="contained"
                                      onClick={() => {
                                        setListItens(
                                          listItens.map((item) => {
                                            return {
                                              ...item,
                                              Tipo: generalConfiguration?.type,
                                              Observacao:
                                                generalConfiguration?.observation,
                                              Motivo:
                                                generalConfiguration?.reason,
                                            };
                                          })
                                        );
                                      }}
                                      disabled={submitting}
                                      style={{
                                        marginLeft: isMobile ? 0 : "auto",
                                        marginRight: isMobile ? 0 : "1rem",
                                        width: isMobile ? "100%" : "auto",
                                      }}
                                    >
                                      Replicar para todos os itens
                                    </Button>
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                            <CardContent>
                              <Grid container>
                                <Grid item xs={12}>
                                  {listItens.map((itemAtendimento, index) => {
                                    return (
                                      <Paper
                                        key={index}
                                        className={classes.paper}
                                      >
                                        <Grid container spacing={1}>
                                          <Grid item>
                                            <ButtonBase
                                              className={classes.image}
                                            >
                                              <ImagePlaceholder
                                                className={classes.img}
                                                alt="Imagem do item do atendimento"
                                                src={itemAtendimento.Foto}
                                                width={75}
                                                widthOnError={40}
                                                imagePreviewTitle={`Item ${itemAtendimento.IdProduto}`}
                                              />
                                            </ButtonBase>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            sm={6}
                                            container
                                            style={{ margin: "0.5rem 0" }}
                                          >
                                            <Grid
                                              item
                                              xs={12}
                                              container
                                              spacing={1}
                                              display="flex"
                                            >
                                              <Grid item xs={12} sm={6}>
                                                <Typography
                                                  gutterBottom
                                                  variant="subtitle2"
                                                  style={{ fontSize: "13px" }}
                                                >
                                                  {
                                                    itemAtendimento.DescricaoProduto
                                                  }
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  color="textSecondary"
                                                  style={{ fontSize: "13px" }}
                                                >
                                                  Código do Produto :{" "}
                                                  {itemAtendimento.IdProduto}
                                                </Typography>
                                                <Typography
                                                  variant="subtitle2"
                                                  style={{ fontSize: "13px" }}
                                                >
                                                  Quantidade Original :{" "}
                                                  {
                                                    itemAtendimento?.QuantidadeOriginal
                                                  }
                                                </Typography>
                                                <>
                                                  {itemAtendimento?.QuantidadeTrocaDev !==
                                                    null && (
                                                    <Typography
                                                      variant="subtitle2"
                                                      style={{
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {`Quantidade ${
                                                        itemAtendimento?.TipoSolicitacao ===
                                                        "DEVOLUCAO"
                                                          ? " Devolução :"
                                                          : " Troca : "
                                                      }`}
                                                      {
                                                        itemAtendimento?.QuantidadeTrocaDev
                                                      }
                                                    </Typography>
                                                  )}
                                                </>
                                                <>
                                                  {itemAtendimento?.QuantidadeRestante !==
                                                    null && (
                                                    <Typography
                                                      variant="subtitle2"
                                                      style={{
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      Quantidade Restante :{" "}
                                                      {
                                                        itemAtendimento.QuantidadeRestante
                                                      }
                                                    </Typography>
                                                  )}
                                                </>
                                              </Grid>

                                              <Grid
                                                item
                                                xs={12}
                                                sm={6}
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <Grid
                                                  container
                                                  style={{
                                                    marginBottom: "-1rem",
                                                  }}
                                                >
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    style={{
                                                      marginBottom: "-1rem",
                                                    }}
                                                  >
                                                    <FormGroup>
                                                      <FormLabel
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        TIPO DE SOLICITAÇÃO
                                                      </FormLabel>
                                                      <RadioGroup
                                                        aria-label="opções de solicitação"
                                                        required
                                                        name="tipo"
                                                        value={
                                                          itemAtendimento?.Tipo
                                                        }
                                                        disabled={
                                                          submitting ||
                                                          itemAtendimento.QuantidadeRestante ===
                                                            0
                                                        }
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                        }}
                                                        onChange={(e) => {
                                                          setListItens(
                                                            listItens.map(
                                                              (item) => {
                                                                if (
                                                                  item?.IdProduto ===
                                                                  itemAtendimento?.IdProduto
                                                                ) {
                                                                  return {
                                                                    ...item,
                                                                    Tipo: e
                                                                      .target
                                                                      .value,
                                                                  };
                                                                } else {
                                                                  return item;
                                                                }
                                                              }
                                                            )
                                                          );
                                                        }}
                                                      >
                                                        {typeExchangeList.map(
                                                          (type) => {
                                                            return (
                                                              <RadioOption
                                                                disabled={
                                                                  submitting ||
                                                                  itemAtendimento.QuantidadeRestante ===
                                                                    0
                                                                }
                                                                className={
                                                                  classes.smallRadioButton
                                                                }
                                                                key={type?.id}
                                                                value={
                                                                  type?.value
                                                                }
                                                                checked={
                                                                  itemAtendimento?.Tipo ===
                                                                  type?.value
                                                                }
                                                                control={
                                                                  <Radio color="primary" />
                                                                }
                                                                label={
                                                                  type.name
                                                                }
                                                              />
                                                            );
                                                          }
                                                        )}
                                                      </RadioGroup>
                                                    </FormGroup>
                                                  </Grid>
                                                </Grid>
                                                <Grid container>
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={6}
                                                    style={{
                                                      marginBottom: isMobile
                                                        ? "1rem"
                                                        : 0,
                                                    }}
                                                  >
                                                    <FormGroup>
                                                      <FormLabel
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        MOTIVO
                                                      </FormLabel>
                                                      <FormControl
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled={
                                                          submitting ||
                                                          itemAtendimento.QuantidadeRestante ===
                                                            0
                                                        }
                                                        style={{
                                                          height: "0.5rem",
                                                        }}
                                                      >
                                                        <Select
                                                          style={{
                                                            height: "2rem",
                                                          }}
                                                          name="motivo"
                                                          value={
                                                            itemAtendimento.QuantidadeRestante ===
                                                            0
                                                              ? ""
                                                              : itemAtendimento?.Motivo
                                                          }
                                                          onChange={(e) =>
                                                            setListItens(
                                                              listItens.map(
                                                                (item) => {
                                                                  if (
                                                                    item?.IdProduto ===
                                                                    itemAtendimento?.IdProduto
                                                                  ) {
                                                                    if (
                                                                      e.target
                                                                        .value !==
                                                                      ""
                                                                    ) {
                                                                      return {
                                                                        ...item,
                                                                        Motivo:
                                                                          e
                                                                            .target
                                                                            .value,
                                                                      };
                                                                    } else {
                                                                      return {
                                                                        ...item,
                                                                        Motivo:
                                                                          "",
                                                                      };
                                                                    }
                                                                  } else {
                                                                    return item;
                                                                  }
                                                                }
                                                              )
                                                            )
                                                          }
                                                          IconComponent={
                                                            KeyboardArrowDown
                                                          }
                                                        >
                                                          <MenuItem value={""}>
                                                            Selecione...
                                                          </MenuItem>
                                                          <MenuItem
                                                            value={
                                                              "ARREPENDIMENTO"
                                                            }
                                                          >
                                                            Arrependimento/Desistência
                                                          </MenuItem>
                                                          <MenuItem
                                                            value={"DEFEITO"}
                                                          >
                                                            Produto com defeito
                                                          </MenuItem>
                                                          <MenuItem
                                                            value={"NAOGOSTOU"}
                                                          >
                                                            Não gostou
                                                          </MenuItem>
                                                          <MenuItem
                                                            value={"OUTROS"}
                                                          >
                                                            Outros
                                                          </MenuItem>
                                                        </Select>
                                                      </FormControl>
                                                    </FormGroup>
                                                  </Grid>
                                                  <Grid item xs={12} sm={6}>
                                                    <FormGroup>
                                                      <FormLabel
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        QUANTIDADE
                                                      </FormLabel>
                                                      <TextField
                                                        name="quantidade"
                                                        type="number"
                                                        fullWidth
                                                        disabled={
                                                          submitting ||
                                                          itemAtendimento.QuantidadeRestante ===
                                                            0
                                                        }
                                                        value={
                                                          itemAtendimento?.QuantidadeSolicitada
                                                        }
                                                        variant="outlined"
                                                        inputProps={{
                                                          max: itemAtendimento?.QuantidadeRestante
                                                            ? itemAtendimento?.QuantidadeRestante
                                                            : itemAtendimento?.QuantidadeOriginal,
                                                          min: 0,
                                                          onKeyDown: (
                                                            event
                                                          ) => {
                                                            event.preventDefault();
                                                          },
                                                          style: {
                                                            height: "2rem",
                                                          },
                                                        }}
                                                        onInput={(e) => {
                                                          setListItens(
                                                            listItens.map(
                                                              (item) => {
                                                                if (
                                                                  item?.IdProduto ===
                                                                  itemAtendimento?.IdProduto
                                                                ) {
                                                                  if (
                                                                    e.target
                                                                      .value !==
                                                                    "0"
                                                                  ) {
                                                                    return {
                                                                      ...item,
                                                                      QuantidadeSolicitada:
                                                                        parseInt(
                                                                          e
                                                                            .target
                                                                            .value
                                                                        ),
                                                                    };
                                                                  } else {
                                                                    return {
                                                                      ...item,
                                                                      QuantidadeSolicitada:
                                                                        "",
                                                                    };
                                                                  }
                                                                } else {
                                                                  return item;
                                                                }
                                                              }
                                                            )
                                                          );
                                                        }}
                                                      />
                                                    </FormGroup>
                                                  </Grid>
                                                </Grid>

                                                <Grid
                                                  container
                                                  style={{
                                                    marginBottom: "-1rem",
                                                  }}
                                                >
                                                  <Grid item xs={12}>
                                                    <FormGroup>
                                                      <FormLabel
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        OBSERVAÇÃO
                                                      </FormLabel>
                                                      <TextField
                                                        name="observacao"
                                                        fullWidth
                                                        multiline
                                                        rows="3"
                                                        onChange={(e) => {
                                                          setListItens(
                                                            listItens.map(
                                                              (item) => {
                                                                if (
                                                                  item?.IdProduto ===
                                                                  itemAtendimento?.IdProduto
                                                                ) {
                                                                  if (
                                                                    e.target
                                                                      .value !==
                                                                    ""
                                                                  ) {
                                                                    return {
                                                                      ...item,
                                                                      Observacao:
                                                                        e.target
                                                                          .value,
                                                                    };
                                                                  } else {
                                                                    return {
                                                                      ...item,
                                                                      Observacao:
                                                                        "",
                                                                    };
                                                                  }
                                                                } else {
                                                                  return item;
                                                                }
                                                              }
                                                            )
                                                          );
                                                        }}
                                                        disabled={
                                                          submitting ||
                                                          itemAtendimento.QuantidadeRestante ===
                                                            0
                                                        }
                                                        value={
                                                          itemAtendimento.QuantidadeRestante ===
                                                          0
                                                            ? ""
                                                            : itemAtendimento?.Observacao
                                                        }
                                                        variant="outlined"
                                                        inputProps={{ min: 0 }}
                                                        onInput={(e) => {
                                                          e.target.value =
                                                            e.target.value
                                                              .toString()
                                                              .slice(0, 250);
                                                        }}
                                                      />
                                                    </FormGroup>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })}
                                </Grid>
                              </Grid>
                            </CardContent>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      hidden={listUnavailableItems?.length === 0 || searching}
                    >
                      <Grid item xs={12}>
                        <Accordion
                          expanded={expanded === "indisponiveis"}
                          onChange={handleChange("indisponiveis")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <Typography
                              style={{ fontWeight: "bold" }}
                              className={classes.heading}
                            >
                              Itens Indisponíveis
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ padding: 0 }}>
                            <CardContent>
                              <Grid container>
                                <Grid item xs={12}>
                                  {listUnavailableItems.map(
                                    (itemAtendimento, index) => {
                                      return (
                                        <Paper
                                          key={index}
                                          className={classes.paper}
                                        >
                                          <Grid container spacing={1}>
                                            <Grid item>
                                              <ButtonBase
                                                className={classes.image}
                                              >
                                                <ImagePlaceholder
                                                  className={classes.img}
                                                  alt="Imagem do item do atendimento"
                                                  src={itemAtendimento.Foto}
                                                  width={75}
                                                  widthOnError={40}
                                                  imagePreviewTitle={`Item ${itemAtendimento.IdProduto}`}
                                                />
                                              </ButtonBase>
                                            </Grid>
                                            <Grid
                                              item
                                              xs={12}
                                              sm={6}
                                              container
                                              style={{ margin: "0.5rem 0" }}
                                            >
                                              <Grid
                                                item
                                                xs={isMobile ? 12 : "auto"}
                                                container
                                                spacing={1}
                                                display="flex"
                                              >
                                                <Grid item xs={12} sm={6}>
                                                  <Typography
                                                    gutterBottom
                                                    variant="subtitle2"
                                                    style={{ fontSize: "13px" }}
                                                  >
                                                    {
                                                      itemAtendimento.DescricaoProduto
                                                    }
                                                  </Typography>
                                                  <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    style={{ fontSize: "13px" }}
                                                  >
                                                    Código do Produto :{" "}
                                                    {itemAtendimento.IdProduto}
                                                  </Typography>
                                                  <Typography
                                                    variant="subtitle2"
                                                    style={{ fontSize: "13px" }}
                                                  >
                                                    Quantidade Original :{" "}
                                                    {
                                                      itemAtendimento?.QuantidadeOriginal
                                                    }
                                                  </Typography>
                                                  <>
                                                    {itemAtendimento?.QuantidadeTrocaDev !==
                                                      null && (
                                                      <Typography
                                                        variant="subtitle2"
                                                        style={{
                                                          fontSize: "13px",
                                                        }}
                                                      >
                                                        {`Quantidade ${
                                                          itemAtendimento?.TipoSolicitacao ===
                                                          "DEVOLUCAO"
                                                            ? " Devolução :"
                                                            : " Troca : "
                                                        }`}
                                                        {
                                                          itemAtendimento?.QuantidadeTrocaDev
                                                        }
                                                      </Typography>
                                                    )}
                                                  </>
                                                  <>
                                                    {itemAtendimento?.QuantidadeRestante !==
                                                      null && (
                                                      <Typography
                                                        variant="subtitle2"
                                                        style={{
                                                          fontSize: "13px",
                                                        }}
                                                      >
                                                        Quantidade Restante :{" "}
                                                        {
                                                          itemAtendimento.QuantidadeRestante
                                                        }
                                                      </Typography>
                                                    )}
                                                  </>
                                                </Grid>

                                                <Grid
                                                  item
                                                  xs={12}
                                                  sm={6}
                                                  style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                  }}
                                                >
                                                  <Grid
                                                    container
                                                    style={{
                                                      marginBottom: "-1rem",
                                                    }}
                                                  >
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      style={{
                                                        marginBottom: "-1rem",
                                                      }}
                                                    >
                                                      <FormGroup>
                                                        <FormLabel
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          TIPO DE SOLICITAÇÃO
                                                        </FormLabel>
                                                        <RadioGroup
                                                          aria-label="opções de solicitação"
                                                          required
                                                          name="tipo"
                                                          value={
                                                            itemAtendimento?.Tipo
                                                          }
                                                          disabled
                                                          style={{
                                                            display: "flex",
                                                            flexDirection:
                                                              "row",
                                                          }}
                                                        >
                                                          {typeExchangeList.map(
                                                            (type) => {
                                                              return (
                                                                <RadioOption
                                                                  disabled
                                                                  className={
                                                                    classes.smallRadioButton
                                                                  }
                                                                  key={type?.id}
                                                                  value={
                                                                    type?.value
                                                                  }
                                                                  checked={
                                                                    itemAtendimento?.Tipo ===
                                                                    type?.value
                                                                  }
                                                                  control={
                                                                    <Radio color="primary" />
                                                                  }
                                                                  label={
                                                                    type.name
                                                                  }
                                                                />
                                                              );
                                                            }
                                                          )}
                                                        </RadioGroup>
                                                      </FormGroup>
                                                    </Grid>
                                                  </Grid>
                                                  <Grid container>
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      sm={6}
                                                      style={{
                                                        marginBottom: isMobile
                                                          ? "1rem"
                                                          : 0,
                                                      }}
                                                    >
                                                      <FormGroup>
                                                        <FormLabel
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          MOTIVO
                                                        </FormLabel>
                                                        <FormControl
                                                          variant="outlined"
                                                          fullWidth
                                                          disabled
                                                          style={{
                                                            height: "0.5rem",
                                                          }}
                                                        >
                                                          <Select
                                                            style={{
                                                              height: "2rem",
                                                            }}
                                                            name="motivo"
                                                            value={
                                                              itemAtendimento.QuantidadeRestante ===
                                                              0
                                                                ? ""
                                                                : itemAtendimento?.Motivo
                                                            }
                                                            IconComponent={
                                                              KeyboardArrowDown
                                                            }
                                                          >
                                                            <MenuItem
                                                              value={""}
                                                            >
                                                              Selecione...
                                                            </MenuItem>
                                                            <MenuItem
                                                              value={
                                                                "ARREPENDIMENTO"
                                                              }
                                                            >
                                                              Arrependimento/Desistência
                                                            </MenuItem>
                                                            <MenuItem
                                                              value={"DEFEITO"}
                                                            >
                                                              Produto com
                                                              defeito
                                                            </MenuItem>
                                                            <MenuItem
                                                              value={
                                                                "NAOGOSTOU"
                                                              }
                                                            >
                                                              Não gostou
                                                            </MenuItem>
                                                            <MenuItem
                                                              value={"OUTROS"}
                                                            >
                                                              Outros
                                                            </MenuItem>
                                                          </Select>
                                                        </FormControl>
                                                      </FormGroup>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                      <FormGroup>
                                                        <FormLabel
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          QUANTIDADE
                                                        </FormLabel>
                                                        <TextField
                                                          name="quantidade"
                                                          type="number"
                                                          fullWidth
                                                          disabled
                                                          value={
                                                            itemAtendimento?.QuantidadeSolicitada
                                                          }
                                                          variant="outlined"
                                                          inputProps={{
                                                            max: itemAtendimento?.QuantidadeRestante
                                                              ? itemAtendimento?.QuantidadeRestante
                                                              : itemAtendimento?.QuantidadeOriginal,
                                                            min: 0,
                                                            onKeyDown: (
                                                              event
                                                            ) => {
                                                              event.preventDefault();
                                                            },
                                                            style: {
                                                              height: "2rem",
                                                            },
                                                          }}
                                                        />
                                                      </FormGroup>
                                                    </Grid>
                                                  </Grid>

                                                  <Grid
                                                    container
                                                    style={{
                                                      marginBottom: "-1rem",
                                                    }}
                                                  >
                                                    <Grid item xs={12}>
                                                      <FormGroup>
                                                        <FormLabel
                                                          style={{
                                                            fontSize: "12px",
                                                          }}
                                                        >
                                                          OBSERVAÇÃO
                                                        </FormLabel>
                                                        <TextField
                                                          name="observacao"
                                                          fullWidth
                                                          multiline
                                                          rows="3"
                                                          disabled
                                                          value={
                                                            itemAtendimento.QuantidadeRestante ===
                                                            0
                                                              ? ""
                                                              : itemAtendimento?.Observacao
                                                          }
                                                          variant="outlined"
                                                          inputProps={{
                                                            min: 0,
                                                          }}
                                                          onInput={(e) => {
                                                            e.target.value =
                                                              e.target.value
                                                                .toString()
                                                                .slice(0, 250);
                                                          }}
                                                        />
                                                      </FormGroup>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Paper>
                                      );
                                    }
                                  )}
                                </Grid>
                              </Grid>
                            </CardContent>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            </DialogContent>

            <DialogActions>
              <Button component={Box} onClick={onClose} disabled={submitting}>
                Cancelar
              </Button>
              <Button
                component={Box}
                onClick={verifyRequiredProps}
                color="default"
                variant="contained"
                disabled={submitting}
              >
                {submitting ? "Enviando solicitação..." : "Solicitar"}
                {submitting ? (
                  <CircularProgress style={{ marginLeft: 5 }} size={16} />
                ) : null}
              </Button>
            </DialogActions>
          </>
        )}
      </>

      {openConfirmation && (
        <OrderConfirmation
          itens={listItemsToChange}
          onClose={({ confirmation }) => {
            if (confirmation) {
              setOpenConfirmation(false);
              onSubmit();
            } else {
              setOpenConfirmation(false);
            }
          }}
        />
      )}
    </Dialog>
  );
};

export default ProductExchangeDialog;
